export const customStyles = {
	control: (styles, { isFocused, isDisabled, selectProps }) => ({
		...styles,
		backgroundColor: isDisabled ? '#EBEBEB' : '#FFFFFF',
		paddingTop:
			selectProps.isSearchable && selectProps.name !== 'accessLevel'
				? 11
				: selectProps.name === 'accessLevel'
				? 10
				: 16,
		paddingBottom:
			selectProps.isSearchable && selectProps.name !== 'accessLevel'
				? 11
				: selectProps.name === 'accessLevel'
				? 10
				: 16,
		paddingLeft: 5,
		paddingRight: 5,
		borderRadius: 12,
		borderWidth: isFocused ? 2 : isDisabled ? 0 : selectProps.isError ? 1.5 : 1,
		borderColor: isFocused
			? '#1A1A1A'
			: selectProps.isError
			? '#CC3434'
			: '#BDBDBD',
	}),
	input: (styles) => ({
		...styles,
		color: '#1A1A1A',
		fontSize: 18,
		fontFamily: 'Inter-Regular',
	}),
	menu: (styles) => ({
		...styles,
		borderRadius: 12,
		zIndex: 999,
		padding: 12,
	}),
	menuPortal: (styles) => ({
		...styles,
		zIndex: 9999,
	}),
	option: (styles, { isFocused, isSelected }) => ({
		...styles,
		color: '#1A1A1A',
		fontSize: 18,
		fontFamily: 'Inter-Regular',
		padding: 10,
		backgroundColor: (isFocused && 'transparent') || (isSelected && '#F5F5F5'),
		':hover': {
			...styles[':hover'],
			backgroundColor: '#F5F5F5',
		},
	}),
	singleValue: (provided) => ({
		...provided,
		color: '#1A1A1A',
		fontSize: 18,
		fontFamily: 'Inter-Regular',
	}),
	placeholder: (styles, { isDisabled }) => ({
		...styles,
		color: isDisabled ? '#9E9E9E' : '#1A1A1A',
		fontSize: 18,
		fontFamily: 'Inter-Regular',
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		transition: 'all .2s ease',
		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
	}),
};
